const base = require('app_adyen_SFRA/adyen/checkout/helpers');

const store = require('app_adyen_SFRA/../../../config/store');
const constants = require('app_adyen_SFRA/../../../config/constants');
const { isFieldEmpty } = require('../../common/utils/dom');

const STORED_CARD = 'storedCard';

function isCardHolderValid(selectedMethodElement) {
  if (!selectedMethodElement) return false;
  const {
    default: getFrontConfig,
  } = require('app_byl_core/common/getFrontConfig');

  const FRONT_CONFIG = getFrontConfig();
  const cardHolderInput = selectedMethodElement.querySelector(
    '.adyen-checkout__card__holderName input'
  );
  let isValid = false;
  const textRegexp = new RegExp(FRONT_CONFIG.textRegex, 'u');
  if (textRegexp.test(cardHolderInput.value)) {
    isValid = true;
  }
  return isValid;
}

function isFieldVisible(field) {
  const style = getComputedStyle(field);
  if (style.display === 'none') return false;
  return true;
}

function selectHasOptions(select) {
  const options = select.querySelectorAll('option');
  return !!(options && options.length > 0);
}

/**
 * Checks if Custom Installment field exists and is not empty
 * @param {HTMLElement} installmentsField
 * @returns {boolean}
 */
function isInstallmentValid(installmentsField) {
  if (
    installmentsField &&
    isFieldVisible(installmentsField) &&
    selectHasOptions(installmentsField.querySelector('select')) &&
    isFieldEmpty(installmentsField.querySelector('select'))
  ) {
    return false;
  }
  return true;
}

function showInstallmentError(installmentsField) {
  const labelErrorElement = document.createElement('span');
  labelErrorElement.classList.add('adyen-checkout__error-text');
  const customInstallmentsErrorText =
    document.getElementById('paymentMethodsList')?.dataset.requiredErrorMsg;
  labelErrorElement.textContent = customInstallmentsErrorText;
  installmentsField?.appendChild(labelErrorElement);
}

function validateNewPaymentForm() {
  $('.adyen-checkout__input').removeClass('adyen-checkout__input--error');

  store.selectedPayment?.node.showValidation();

  const selectedMethodElement = document
    .querySelector(
      `.adyen-payment-method-type__input[id*=${store.selectedMethod}]`
    )
    ?.closest('.adyen-payment-method-type');
  const cardHolderLabelElement = selectedMethodElement?.querySelector(
    '.adyen-checkout__card__holderName .adyen-checkout__label'
  );

  if (isCardHolderValid(selectedMethodElement)) {
    // Remove error class to adyen input element
    cardHolderLabelElement
      ?.querySelector('.adyen-checkout__error-text')
      ?.remove();
    // Show adyen input element valid icon
    cardHolderLabelElement
      ?.querySelector('.adyen-checkout-input__inline-validation--valid')
      ?.classList.remove('d-none');
  } else {
    // Add cardHolder error message
    if (
      cardHolderLabelElement !== null &&
      !cardHolderLabelElement.querySelector('.adyen-checkout__error-text')
    ) {
      // Add new error message element
      const labelErrorElement = document.createElement('span');
      labelErrorElement.classList.add('adyen-checkout__error-text');
      const cardHolderErrorText =
        document.getElementById('paymentMethodsList')?.dataset.cardHolderError;
      labelErrorElement.textContent = cardHolderErrorText;
      cardHolderLabelElement.appendChild(labelErrorElement);
    }

    // Add error class to adyen input element
    $(
      '.adyen-checkout__input.adyen-checkout__card__holderName__input'
    ).addClass('adyen-checkout__input--error');
    // Hide adyen input element valid icon
    cardHolderLabelElement
      ?.querySelector('.adyen-checkout-input__inline-validation--valid')
      ?.classList.add('d-none');

    return false;
  }

  const installmentsField = selectedMethodElement.querySelector(
    '.adyen-checkout__custominstallments'
  );

  if (isInstallmentValid(installmentsField)) {
    installmentsField?.querySelector('.adyen-checkout__error-text')?.remove();
  } else {
    showInstallmentError(installmentsField);
    return false;
  }

  return true;
}

function validateSavedPaymentForm() {
  $('.adyen-checkout__input').removeClass('adyen-checkout__input--error');
  store.selectedPayment?.node.showValidation();

  const selectedMethodElement = document
    .querySelector(
      `.adyen-payment-method-type__input[id*=${store.selectedMethod}]`
    )
    ?.closest('.adyen-payment-method-type');
  const installmentsField = selectedMethodElement?.querySelector(
    '.adyen-checkout__custominstallments'
  );

  if (isInstallmentValid(installmentsField)) {
    installmentsField?.querySelector('.adyen-checkout__error-text')?.remove();
  } else {
    showInstallmentError(installmentsField);
    return false;
  }

  return true;
}

function displayValidationErrors() {
  let _store$selectedMethod;
  if (
    // eslint-disable-next-line no-cond-assign
    (_store$selectedMethod = store.selectedMethod) !== null &&
    // eslint-disable-next-line no-void
    _store$selectedMethod !== void 0 &&
    _store$selectedMethod.node
  ) {
    store.selectedPayment.node.showValidation();
  }
  return false;
}

const selectedMethods = {
  scheme: validateNewPaymentForm,
  [STORED_CARD]: validateSavedPaymentForm,
};

function doCustomValidation() {
  let { selectedMethod } = store;
  if (store.selectedMethod.indexOf(STORED_CARD) === 0) {
    selectedMethod = STORED_CARD;
  }

  return selectedMethod in selectedMethods
    ? selectedMethods[selectedMethod]()
    : true;
}

function showValidation() {
  return store.selectedPaymentIsValid
    ? doCustomValidation()
    : displayValidationErrors();
}

function resetPaymentMethod() {
  $('#requiredBrandCode').hide();
  $('#selectedIssuer').val('');
  $('#adyenIssuerName').val('');
  $('#dateOfBirth').val('');
  $('#telephoneNumber').val('');
  $('#gender').val('');
  $('#bankAccountOwnerName').val('');
  $('#bankAccountNumber').val('');
  $('#bankLocationId').val('');
  $('.additionalFields').hide();
}

/**
 * Changes the "display" attribute of the selected method from hidden to visible
 */
function displaySelectedMethod(type) {
  let _document$querySelect2;
  // If 'type' input field is present use this as type, otherwise default to function input param
  store.selectedMethod = document.querySelector(
    '#component_'.concat(type, ' .type')
  )
    ? document.querySelector('#component_'.concat(type, ' .type')).value
    : type;
  resetPaymentMethod();

  const disabledSubmitButtonMethods = constants.DISABLED_SUBMIT_BUTTON_METHODS;
  if (window.klarnaWidgetEnabled) {
    disabledSubmitButtonMethods.push('klarna');
  }
  document.querySelector('.place-order-btn').disabled =
    disabledSubmitButtonMethods.findIndex((pm) => type.includes(pm)) > -1;
  document
    .querySelector('#component_'.concat(type))
    ?.setAttribute('style', 'display:block');
  // set brand for giftcards if hidden inputfield is present
  store.brand =
    // eslint-disable-next-line no-cond-assign
    (_document$querySelect2 = document.querySelector(
      '#component_'.concat(type, ' .brand')
      // eslint-disable-next-line no-void
    )) === null || _document$querySelect2 === void 0
      ? // eslint-disable-next-line no-void
        void 0
      : _document$querySelect2.value;
}

module.exports = Object.assign(base, {
  displaySelectedMethod,
  showValidation,
});
